import { Icon } from '@platform/components';
import { ReactNode } from 'react';
import { HeaderFooterLayout } from '../app';
import FlexibleLink from '../util/FlexibleLink';

export type DirectoryBackLink = {
  label: string;
  href: string;
};

export const DirectoryLayout = ({
  children,
  backLink,
  banner,
}: {
  children: React.ReactNode;
  backLink?: DirectoryBackLink;
  banner?: ReactNode;
}) => {
  return (
    <HeaderFooterLayout useDashboardHeader withSidebar={false} banner={banner}>
      {backLink && (
        <FlexibleLink
          href={backLink.href}
          type='internal'
          className='w-fit flex items-center gap-1.5 py-2 text-sm font-semibold text-brand-500 hover:underline'
        >
          <Icon type='arrow-left' size='20' stroke='brand-500' />
          {backLink.label}
        </FlexibleLink>
      )}
      <div className='min-h-[1280px] relative bg-white'>{children}</div>
    </HeaderFooterLayout>
  );
};
